import { render, staticRenderFns } from "./MaterialsManager.vue?vue&type=template&id=cd7522da"
import script from "./MaterialsManager.vue?vue&type=script&lang=js"
export * from "./MaterialsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports